export default {
    namespaced: true,
    state: {
        chosenSectors: [],
        dueDilligence: false,
        lcpRating: {
            buy: true,
            hold: true,
            review: true,
            unrated: true,
        },
		openFundsOnly: false,
		allData: true,
        data: [],
    },
    getters: {},
    actions: {
        updateUniverse ({ commit, dispatch }, universe) {
            commit('setChosenSectors', universe.chosenSectors);
            commit('setDueDilligence', universe.dueDilligence);
            commit('setLcpRating', universe.lcpRating);
			commit('setOpenFundsOnly', universe.openFundsOnly);
			commit('setAllData', universe.allData);
            dispatch('setUniverse');
        },
        setUniverse ({ commit, rootState, state }) {
            const universeData = _.cloneDeep(rootState.pensionsData);

            for (let filter = 0; filter < universeData.categoryDimensions.length; filter += 1) {
                switch (universeData.categoryDimensions[filter].name) {
                case 'Asset class':
                    if (state.chosenSectors.length > 0) {
                        universeData.categoryDimensions[filter].order = state.chosenSectors;
                    } else {
                        universeData.categoryDimensions[filter] = rootState.pensionsData.categoryDimensions[filter];
                    }
                    break;
                case 'LCP rating':
                    const order = [];
                    state.lcpRating.buy ? order.push('Buy') : '';
                    state.lcpRating.hold ? order.push('Hold') : '';
                    state.lcpRating.review ? order.push('Review') : '';
                    state.lcpRating.unrated ? order.push('Unrated') : '';
                    universeData.categoryDimensions[filter].order = order;
                    universeData.categoryDimensions[filter].orderNames = order;
                    break;
                default:
                    break;
                }
            }
            for (let d = universeData.data.length - 1; d >= 0; d -= 1) {
                let cont = true;

                if (state.chosenSectors.length > 0) {
                    if (!state.chosenSectors.includes(universeData.data[d].categories[0])) {
                        universeData.data.splice(d, 1);
                        cont = false;
                    }
                }

                if (cont) {
                    const fundIndex = universeData.allMetaData.findIndex(x => x.Guid === universeData.data[d].id);
                    if (fundIndex > -1) {
                        if (state.dueDilligence) {
                            if (universeData.allMetaData[fundIndex].LcpDueDilligence !== 'Pass') {
                                universeData.data.splice(d, 1);
                                cont = false;
                            }
                        }

                        if (state.openFundsOnly) {
                            if (universeData.allMetaData[fundIndex].FundOpenOrClosed !== 'Yes') {
                                universeData.data.splice(d, 1);
                                cont = false;
                            }
                        }
                    }
                }

                // / looks like when we are setting the new data we are not finding the one from the original data we are just expectibg them to match up which is throwing incorrect results
                // console.log(universeData.data[d].categories[2]);

                if (cont) {
                    // console.log(`${universeData.data[d].ticker} - ${universeData.data[d].categories[0]}`);
                    const test = universeData.categoryDimensions[2];
                    const ordered = test.order;
                    const searchItem = universeData.data[d].categories[2];
                    const index = ordered.findIndex(rating => rating === searchItem);
                    // const ri = universeData.categoryDimensions[2].order.findIndex(rating => rating === universeData.data[d].categories[2]);
                    index === -1 ? universeData.data.splice(d, 1) : '';
                }
            }
            // universeData.data = newArray;
            // console.log(universeData.data);
            commit('setUniverseData', universeData);
        },
    },
    mutations: {
        setChosenSectors (state, chosenSectors) {
            state.chosenSectors = chosenSectors;
        },
        setDueDilligence (state, dueDilligence) {
            state.dueDilligence = dueDilligence;
        },
        setLcpRating (state, lcpRating) {
            state.lcpRating = lcpRating;
        },
        setOpenFundsOnly (state, openFundsOnly) {
            state.openFundsOnly = openFundsOnly;
		},
        setAllData (state, allData) {
            state.allData = allData;
        },
        setUniverseData (state, data) {
            state.data = data;
        },
    },
};
